import {v3} from "oc-threejs/short3.js";
import Restraint from "./Restraint";
import Connector from "../connectors/Connector";

/**
 * Ermittelt für DragObject3d-Objekte, die einen Anchor haben, die Offset-Position dieses Anchors.
 * @template {{new (...args: any[]) => {}} Super
 * @param {Super} superClass
 */
const AnchorAwareMixin = (superClass=Restraint) => class AnchorAwareMix extends superClass  {

    /** @type {?Connector} */
    anchor;
    /** @type {THREE.Matrix4} */
    anchorMatrix;
    /** @type {THREE.Matrix4} */
    anchorMatrixInverse;
    /** @type {THREE.Vector3} */
    anchorDeltaPosition;
    /** @type {?string} */
    anchorName;

    constructor(options) {
        super(options);
        this.anchorName = (options && options.anchorName) || null;
    }

    /**
     * @param {THREE.Ray} ray
     * @returns {?THREE.Vector3}
     */
    raycastLocal(ray) {
        ray.origin.add(this.anchorDeltaPosition);
        const point = super.raycastLocal(ray);
        // if (point) {
        //     point.sub(this.anchorDeltaPosition);
        // }
        return point;
    }

    /**
     * @param {THREE.Object3D} dragObject3d
     * @param {THREE.Box3} dragObject3dBoundingBoxLocal
     */
    setDragObject3d(dragObject3d, dragObject3dBoundingBoxLocal) {
        super.setDragObject3d(dragObject3d,dragObject3dBoundingBoxLocal);
        this.anchor = this.getAnchor();
        if (this.anchor) {
            this.anchorMatrix = this.anchor.matrix.clone();
        } else {
            this.setDefaultAnchorMatrix();
        }
        if (this.anchorMatrix) {
            this.anchorMatrixInverse = new THREE.Matrix4().copy(this.anchorMatrix).invert();
            this.anchorDeltaPosition =  v3().setFromMatrixPosition(this.anchorMatrix);
        }
    }

    setDefaultAnchorMatrix() {
        this.anchorMatrix = new THREE.Matrix4();
    }

    getAnchor() {
        return this.dragObject3d.getAnchor(this.anchorName);
    }
}

export default AnchorAwareMixin;
